import { Component, inject, ViewChildren, QueryList, ElementRef, OnInit, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from 'src/app/shared/shared.module';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AdminHierarchyService } from 'src/app/services/admin-hierarchy.service';
import { HttpErrorResponse } from '@angular/common/http';
import { error } from 'console';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiResponse } from 'src/app/core/models/api-response.model';
import { BranchService } from 'src/app/services/branches.service';
import { ToastrService } from 'ngx-toastr';

interface Hierarchy {
  id: number;
  name: string;
}

@Component({
  selector: 'app-add-branch',
  standalone: true,
  imports: [CommonModule, SharedModule, NgSelectModule, FormsModule, ReactiveFormsModule],
  templateUrl: './add-branch.component.html',
  styleUrl: './add-branch.component.scss'
})
export class AddBranchComponent implements OnInit {


  constructor(private modalService: NgbModal, private fb: FormBuilder) { }

  submittedData: boolean = false;
  admin_hierarchy: Hierarchy[] = [];
  form!: FormGroup;
  isSubmitted: boolean = false;
  modalRef!: NgbModalRef;

  private adminHierarchyService = inject(AdminHierarchyService);
  private branchesService = inject(BranchService);
  private ngxLoader = inject(NgxUiLoaderService);
  private toastr = inject(ToastrService);


  @ViewChild('branchModal', { static: true }) branchModal!: TemplateRef<any>;

  // pass the value parent to child
  @Output() branchAdded = new EventEmitter<void>();

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm() {
    this.form = this.fb.group({
      administrative_hierarchy_id: [null, Validators.required],
      name: ['', [Validators.required, Validators.maxLength(45)]],
      branch_code: ['', [Validators.required, Validators.maxLength(155)]],
    });
  }

  addBranchModal() {
    this.modalRef = this.modalService.open(this.branchModal, { size: 'lg', centered: false, backdrop: 'static' });
    this.getAllHierarchy();
    this.modalRef.dismissed.subscribe((() => {
      this.clearData();
    }))
  }

  getAllHierarchy() {
    this.ngxLoader.start();
    this.adminHierarchyService.findAll().subscribe({
      next: (response: ApiResponse) => {
        this.admin_hierarchy = response.data.map((detail: { id: number, name: string }) => ({
          id: detail.id,
          name: detail.name
        }));
        this.ngxLoader.stop();
      }, error: (err: HttpErrorResponse) => {
        this.ngxLoader.stop()
        throw err;
      }
    });
  }

  onSubmit() {
    this.isSubmitted = true;
    if (this.form.valid) {
      this.ngxLoader.start();
      const payload = this.form.getRawValue();
      console.log('yoo payload :', payload);
      this.branchesService.create(payload).subscribe({
        next: (response: ApiResponse) => {
          this.ngxLoader.stop();
          this.isSubmitted = false;
          this.clearData();
          this.modalRef.close();
          this.branchAdded.emit();
          this.toastr.success("Branch added successfully", "Success");
        }, error: (error: HttpErrorResponse) => {
          this.ngxLoader.start();
          throw error;

        }
      })
    }
  }

  clearData() {
    this.form.reset()
  }




}
